/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Directory_DetailInputs */

const en_features_directory_detail = /** @type {(inputs: Features_Directory_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal trainer · 0.8 km`)
};

const pl_features_directory_detail = /** @type {(inputs: Features_Directory_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenerka personalna · 0,8 km`)
};

/**
* | output |
* | --- |
* | "Personal trainer · 0.8 km" |
*
* @param {Features_Directory_DetailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_directory_detail = /** @type {((inputs?: Features_Directory_DetailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Directory_DetailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_directory_detail(inputs)
	return en_features_directory_detail(inputs)
});